import {
	ImageType,
	Model,
	YardTripDeliveryNote
} from ".";

export default class YardTripDeliveryNoteImage extends Model {
	get singularNoun() {
		return "delivery note image";
	}

	get mutations() {
		return {
			deliveryNote: YardTripDeliveryNote,
			imageType: ImageType
		};
	}

	resource() {
		return "delivery-note/images";
	}
}
